import React from 'react';
import styled from 'styled-components';
import SvgIcon from '../SvgIcon';

const IconReset = styled(SvgIcon).attrs({
  children: ({ color }: { color: string }) => (
    <>
      <defs>
        <path
          d="M16 8a8 8 0 01-15 3.875V14H0V9h5v1H2.342A6 6 0 0014 8zm-1-8v5h-5V4h4v-.001L12.472 4A6.002 6.002 0 002.341 6H.251A8.003 8.003 0 0114 2.709V0h1z"
          id="reset_svg__a"
        />
      </defs>
      <g fill="none" fillRule="evenodd">
        <mask id="reset_svg__b" fill="#fff">
          <use xlinkHref="#reset_svg__a" />
        </mask>
        <use fill="#FFF" xlinkHref="#reset_svg__a" />
        <path fill={color} mask="url(#reset_svg__b)" d="M-5-4h25v25H-5z" />
      </g>
    </>
  ),
})``;

export default IconReset;
